import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'dashboards';
const path_standard_point: string = "edpex-standard-point";
const path_project: string = "edpex-project";



export type miniTableQueryType = {
    keyword?: string;
    fiscal_year_start?: string;
    fiscal_year_end?: string;
    id_department_ref?: number;
    edpex_project_status?: string;
    id_edpex_missions?: string; // 1|3|4
    edpex_project_user_responsibles?: string; // คั่นด้วย |
    id_positions?: number;
    edpex_quarters?: string;//
    edpex_project_division_responsible?: string;
    edpex_project_department_responsibles?: string;// สำนักๅ|lk|12
    id_edpex_standard_point?: number;
    limit: number;
    page: number;
}
export class DashboardsApi extends BaseAPI {
    static allFilter(): Promise<AxiosResponse> {
        return this.api.get(`${path}/all`)
    }
    static findEdPexStandard(): Promise<AxiosResponse> {
        return this.api.get(`${path_standard_point}`)
    }
    static miniTable(query: miniTableQueryType): Promise<AxiosResponse> {
        return this.api.get(`${path}/all/table`, { params: { ...query } })
    }
    static reportDataTable(query: miniTableQueryType): Promise<AxiosResponse> {
        return this.api.get(`${path}/report/data`, { params: { ...query } })
    }
    static excelReport(query: miniTableQueryType): Promise<AxiosResponse> {
        return this.api.get(`${path}/report/excel`, {
            params: { ...query },
            responseType: 'arraybuffer'
        })
    }
    static findOneProjectEdPex(id_edpex_project: number): Promise<AxiosResponse> {
        return this.api.get(`${path_project}/${id_edpex_project}`)
    }
}